(() => {
  // Debug: para ver si está activo
  window.__SLIDE_CLICK_ACTIVE__ = true;

  let startX = 0, startY = 0, moved = false, pointerDown = false;

  const THRESHOLD = 18; // más tolerante para no confundir click con swipe

  const getHrefFromSlide = (slide) => {
    // prioridad 1: el overlay del tema
    const overlay = slide.querySelector("a.swiper-slide-link[href]");
    const href1 = overlay?.getAttribute("href");
    if (href1 && href1 !== "#") return href1;

    // prioridad 2: cualquier link válido dentro del slide
    const any = slide.querySelector("a[href]:not([href='#']):not([href=''])");
    const href2 = any?.getAttribute("href");
    if (href2 && href2 !== "#") return href2;

    // prioridad 3: data-href
    const data = slide.querySelector("[data-href]");
    const href3 = data?.getAttribute("data-href");
    if (href3 && href3 !== "#") return href3;

    return null;
  };

  const onPointerDown = (e) => {
    // solo botón izquierdo en mouse
    if (e.pointerType === "mouse" && e.button !== 0) return;

    pointerDown = true;
    moved = false;
    startX = e.clientX;
    startY = e.clientY;
  };

  const onPointerMove = (e) => {
    if (!pointerDown) return;
    if (Math.abs(e.clientX - startX) > THRESHOLD || Math.abs(e.clientY - startY) > THRESHOLD) {
      moved = true;
    }
  };

  const onPointerUp = (e) => {
    if (!pointerDown) return;
    pointerDown = false;

    // si fue swipe, no navegamos
    if (moved) return;

    // no interferir con flechas/dots
    if (e.target.closest(".swiper-button-next, .swiper-button-prev, .swiper-pagination")) return;

    const slide = e.target.closest(".swiper-slide, [class*='swiper-slide']");
    if (!slide) return;

    const href = getHrefFromSlide(slide);

    // debug: te deja ver qué detectó
    window.__LAST_SLIDE_HREF__ = href;

    if (!href) return;

    window.location.assign(href);
  };

  // Capture TRUE para ganarle a Swiper si bloquea clicks
  document.addEventListener("pointerdown", onPointerDown, true);
  document.addEventListener("pointermove", onPointerMove, true);
  document.addEventListener("pointerup", onPointerUp, true);
})();
